import { css } from 'styled-components';

// Mixin de tooltip reutilizable — insértalo dentro de cualquier styled-component
// y añade el atributo data-tooltip="texto" en el JSX de ese elemento.
// align: 'left' (por defecto, pegado a la izquierda) o 'center' (centrado)
export const tooltipMixin = (align = 'left') => css`
  position: relative;

  &[data-tooltip]:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 6px);
    ${align === 'center'
      ? css`left: 50%; transform: translateX(-50%);`
      : align === 'right'
        ? css`right: 0;`
        : css`left: 0;`}
    background: var(--tooltip-bg, #1a1a2e);
    border: 1px solid rgba(255,255,255,0.12);
    color: var(--tooltip-color, rgb(255, 255, 0));
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
    white-space: var(--tooltip-whitespace, nowrap);
    max-width: var(--tooltip-max-width, none);
    pointer-events: none;
    z-index: 20;
  }
`;